import { KeyRoles } from "../../../../types/enums";
import { Button, CircularProgress } from "@mui/material";
import { campaignsApi, useLazyGetAccountTitleGapsQuery } from "../../../../api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { GetMoreContactsModal } from "../../modal";
import { setIsNotificationsOpen } from "../../../../features/companySlice";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { JobTitle } from "../../../../types/apiTypes";
import { selectPermissions } from "../../../../features/permissionsSlice";

export const GetContactsForRoleBtn = ({
  role,
  isDisabled,
  account_id,
  isLoading,
}: {
  role: KeyRoles;
  account_id: string;
  isDisabled: boolean;
  isLoading: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [isCurrentLoading, setIsCurrentLoading] = useState<boolean>(isLoading);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [titles, setTitles] = useState<JobTitle[]>([]);

  const { isAllowedEditActionsTargetTitles } =
    useAppSelector(selectPermissions);

  const [getAccountTitle, { isFetching: isTitleGapsLoading }] =
    useLazyGetAccountTitleGapsQuery();

  useEffect(() => {
    if (!isDisabled) setIsCurrentLoading(false);
  }, [isDisabled]);

  const refetchHandler = () => {
    dispatch(
      campaignsApi.util.invalidateTags([
        "members",
        "role-members",
        "company",
        "activities",
      ]),
    );
  };

  const onSuccessHandler = () => {
    setIsCurrentLoading(true);
    refetchHandler();
    dispatch(setIsNotificationsOpen(true));
  };

  const onOpenHandler = () => {
    getAccountTitle({ account_id, role })
      .unwrap()
      .then((data) => {
        setTitles(
          data.title_gaps.map((el) => ({
            is_critical: el.is_critical,
            title: el.name,
            id: el.name,
            is_edit: false,
          })),
        );
        setIsOpen(true);
      })
      .catch((err) => {
        toast.error(
          <CustomToast
            type="error"
            title="Failed to find more contacts."
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
          />,
        );
        setIsCurrentLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={onOpenHandler}
        disabled={
          isDisabled || isTitleGapsLoading || !isAllowedEditActionsTargetTitles
        }
        variant="outlined"
        color="warning"
        sx={{ borderRadius: "8px" }}
        startIcon={
          (isCurrentLoading || isTitleGapsLoading) && (
            <CircularProgress size={20} color="inherit" />
          )
        }
      >
        Explore Audience Expansion
      </Button>
      {isOpen && (
        <GetMoreContactsModal
          role={role}
          onSuccess={onSuccessHandler}
          account_id={account_id!}
          initTitles={titles}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          withSuggestions={true}
        />
      )}
    </>
  );
};
